
import {Vue, Component} from 'vue-property-decorator';
import {integrityApi} from "@/api/integrity";

const {regionData, CodeToText} = require("@/js/region/region");
import SelectMechanism from "@/components/SelectMechanism.vue";
import ckeditor4 from "@/components/CkeditorComponent.vue";
import CreditListCommon from "@/views/integrity/CreditListCommon.vue";

@Component({
  components: {
    CreditListCommon,
    ckeditor4, SelectMechanism
  }
})
export default class Order extends Vue {
  private dataList = [];// 企业列表
  private showQuery = false;
  private loading = false;
  private queryParams = {
    start: '',
    end: '',
    categoryName: '',
    supervisedUnitName: '',
    supervisionUnitName: '',
    result: '',
    current: 1,
    size: 10,
    total: 0
  }
  userData = {} as any;
  private showAddDialog = false;
  private formRule = {
    supervisedUnitName: [{required: true, message: '请输入', trigger: 'change'}],
    categoryName: [{required: true, message: '请选择', trigger: 'change'}],
    matterName: [{required: true, message: '请选择', trigger: 'change'}],
    regulatoryDate: [{required: true, message: '请选择', trigger: 'change'}],
    typeName: [{required: true, message: '请选择', trigger: 'change'}],
    reason: [{required: true, message: '请输入', trigger: 'blur'}],
    location: [{required: true, message: '请输入', trigger: 'blur'}],
    result: [{required: true, message: '请输入', trigger: 'blur'}],
    supervisionUnit: [{required: true, message: '请输入', trigger: 'blur'}],
    supervisionUnitName: [{required: true, message: '请输入', trigger: 'blur'}]
  }
  private dataInfo = this.initFrom();
  private mode = "";

  mounted() {
    const userData = this.$store.state.AuthedUser;
    this.userData = userData;
    this.loadData();
  }

  reset() {
    this.queryParams.start = '';
    this.queryParams.end = '';
    this.queryParams.categoryName = '';
    this.queryParams.supervisedUnitName = '';
    this.queryParams.supervisionUnitName = '';
    this.queryParams.result = '';
    this.loadData();
  }

  initFrom() {
    return {
      supervisedUnitNameId: '',
      supervisedUnitId: '',
      supervisedUnitName: '',
      categoryName: '',
      matterName: '',
      regulatoryDate: '',
      typeName: '',
      reason: '',
      location: '',
      result: '',
      supervisionUnit: '',
      supervisionUnitName: '',
    } as any
  }

  loadData() {
    this.loading = true;
    this.clearSelectedTable();
    integrityApi.pageSupervise(this.queryParams).then((r: any) => {
      this.loading = false;
      const res = r.data;
      if (res.result === 0) {
        this.queryParams.total = res.data.total;
        this.dataList = res.data.records;
      }
    }).catch(() => {
      this.loading = false;
    })
  }

  pageSizeChange(val: number) {
    this.queryParams.size = val;
    this.loadData();
  }

  pageCurrentChange(val: number) {
    this.queryParams.current = val;
    this.loadData();
  }

  indexMethod(index: any) {
    return (this.queryParams.current - 1) * this.queryParams.size + index + 1;
  }

  onView() {
    if(this.isCheckedOne()){
      this.dataInfo = this.initFrom();
      this.mode = "view";
      this.dataInfo = JSON.parse(JSON.stringify(this.selectedItems[0]));
      this.showAddDialog = true;
    }
  }

  onDelete(){
    if(this.isCheckedOne()){
      this.$confirm('确定要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const dataInfo = this.selectedItems[0] as any;
        integrityApi.deleteSupervise({id: dataInfo.id, supervisedUnitId: dataInfo.supervisedUnitId}).then((r: any) => {
          if(r.data.result === 0){
            this.$message.success("删除成功！");
            this.loadData();
          }
        });
      });
    }
  }

  onClickTableView(row: any){
    this.dataInfo = this.initFrom();
    this.mode = "view";
    this.dataInfo = JSON.parse(JSON.stringify(row));
    this.showAddDialog = true;
  }

  openAddDialog() {
      this.dataInfo = this.initFrom();
      this.dataInfo.supervisionUnitName = this.userData.organizationName;
      this.dataInfo.supervisionUnit = this.userData.organizationId;
      this.mode = 'save';
      this.showAddDialog = true;
  }

  onClose() {
    this.dataInfo = this.initFrom();
    let form = this.$refs.form as HTMLFormElement;
    form.resetFields();
    this.mode = '';
    this.showAddDialog = false;
  }

  onSave() {
    let form = this.$refs.form as HTMLFormElement;
    form.validate((valid: any) => {
      if (valid) {
        integrityApi.addSupervise(this.dataInfo).then((r: any) => {
          if (r.data.result === 0) {
            this.$message.success("操作成功！");
            this.loadData();
            this.onClose();
          }
        });
      }
    });
  }

  changeOrg(val: any) {
    this.dataInfo.supervisedUnitId = val.mechanismId;
    this.dataInfo.supervisedUnitName = val.mechanismName;
  }

  private selectedItems = [];
  onSelectItem(selection: any, row: any) {
    this.selectedItems = selection;
  }

  isCheckedOne(){
    if(this.isChecked()){
      if(this.selectedItems.length !== 1){
        this.$message.error("请先选择一条记录");
        return false;
      }
    }
    return true;
  }

  isChecked(){
    if(!this.selectedItems || this.selectedItems.length === 0){
      this.$message.error("请先选择一条记录");
      return false;
    }

    return true;
  }
  clearSelectedTable(){
    this.selectedItems = [];
    let $table = this.$refs.table as HTMLFormElement;
    if($table){
      $table.clearSelection();
    }
  }
}
